import { useEffect } from 'react';
import { getEnvironmentTitle } from '../utils/environmentUtils';

const DynamicTitle = () => {
  useEffect(() => {
    // Set title based on environment
    document.title = getEnvironmentTitle();
  }, []);

  return null; // This component doesn't render anything
};

export default DynamicTitle;
